module.exports = __webpack_public_path__ + "static/media/10065.74963a9c.jpg";